export enum QuestionId {
  MOCK = 'mock',

  // User info
  PROVINCE = 'province',
  FIRST_NAME = 'first-name',
  PHONE = 'phone',

  // Humania
  SEX = 'sex',
  SMOKER = 'smoker',
  MARIJUANA = 'marijuana',
  BIRTHDAY = 'birthday',
  HEIGHT = 'height',
  WEIGHT = 'weight',
  CITIZENSHIP = 'citizenship',
  CURRENTLY_WORKING = 'currently-working',
  DRUG_USE = 'drug-use',
  DRUG_TREATMENT = 'drug-treatment',
  CRIMINAL_OFFENCE = 'criminal-offence',
  DIABETES_DIAGNOSIS = 'diabetes-diagnosis',
  DISCOMFORT_SYMPTOMS = 'discomfort-symptoms',
  EXTREME_ACTIVITIES = 'extreme-activities',
  SLEEP_APNEA = 'sleep-apnea',
  RESPIRATORY_DISORDERS = 'respiratory-disorders',
  MUSCULAR_DISORDERS = 'muscular-disorders',
  NEURAL_DISORDERS = 'neural-disorders',
  IMMUNE_DEFICIENCY_DISORDERS = 'immune-deficiency-disorders',
  CHRONIC_PAIN_DISORDERS = 'chronic-pain-disorders',
  PREGNANCY = 'pregnancy',
  WEIGHT_LOSS = 'weight-loss',
  OCCUPATIONAL_DUTIES = 'occupational-duties',
  FAMILIAL_MEDICAL_HISTORY_UNDER_65 = 'familial-medical-history-under-65',
  FAMILIAL_MEDICAL_HISTORY_UNDER_60 = 'familial-medical-history-under-60',
  MEDICAL_INVESTIGATIONS = 'medical-investigations',
  HEART_DISORDERS = 'heart-disorders',
  ENDOCRINE_DISORDERS = 'endocrine-disorders',
  CANCER_OR_OTHERS = 'cancer-or-others',
  GASTROINTESTINAL_DISORDERS = 'gastrointestinal-disorders',
  MULTIPLE_SCLEROSIS = 'multiple-sclerosis',
  EPILEPSY_DISORDERS = 'epilepsy-disorders',
  SEIZURES = 'seizures',
  GENITOURINARY_DISORDERS = 'genitourinary-disorders',
  NERVOUS_DISORDERS = 'nervous-disorders',
  MILD_NERVOUS_DISORDERS = 'mild-nervous-disorders',
  MILD_NERVOUS_DISORDERS_TIME_LOSS = 'mild-nervous-disorders-time-loss',
  MILD_NERVOUS_DISORDERS_HOSPITALIZATION = 'mild-nervous-disorders-hospitalization',
  MILD_NERVOUS_DISORDERS_MEDICATION = 'mild-nervous-disorders-medication',
  SPECIAL_TRAVEL = 'special-travel',
  SLEEP_STUDY = 'sleep-study',
  SLEEP_APNEA_DIAGNOSIS = 'sleep-apnea-diagnosis',
  SLEEP_APNEA_INTENSITY = 'sleep-apnea-intensity',
  SLEEP_APNEA_TREATMENT = 'sleep-apnea-treatment',
  SLEEP_APNEA_COMPLICATIONS = 'sleep-apnea-complications',
  EXTREME_ACTIVITIES_DETAILS = 'extreme-activities-details',
  EXTREME_ACTIVITIES_FUTURE = 'extreme-activities-future',
  EXTREME_ACTIVITIES_OUTSIDE_NORTH_AMERICA = 'extreme-activities-outside-north-america',
  EXTREME_ACTIVITIES_CLUB_MEMBER = 'extreme-activities-club-member',
  EXTREME_ACTIVITIES_COMPENSATION = 'extreme-activities-compensation',
  EXTREME_ACTIVITIES_INJURIES = 'extreme-activities-injuries',
  EXTREME_ACTIVITIES_RECORD = 'extreme-activities-record',
  EXTREME_ACTIVITIES_EXTRA_INFORMATION = 'extreme-activities-extra-information',
  DIABETES_DIAGNOSIS_DETAILS = 'diabetes-diagnosis-details',
  DIABETES_DIAGNOSIS_DOCTOR = 'diabetes-diagnosis-doctor',
  DIABETES_DIAGNOSIS_DOCTOR_LAST_VISIT = 'diabetes-diagnosis-doctor-last-visit',
  DIABETES_DIAGNOSIS_TREATMENT = 'diabetes-diagnosis-treatment',
  DIABETES_DIAGNOSIS_TEST_FREQUENCY = 'diabetes-diagnosis-test-frequency',
  DIABETES_DIAGNOSIS_LAST_TEST_RESULT = 'diabetes-diagnosis-last-test-result',
  DIABETES_DIAGNOSIS_RELATED_HEALTH_PROBLEMS = 'diabetes-diagnosis-related-health-problems',
  ELECTROCARDIOGRAM = 'electrocardiogram',
  DIABETES_DIAGNOSIS_TOBACCO = 'diabetes-diagnosis-tobacco',
  SPECIAL_TRAVEL_CURRENT_YEAR = 'special-travel-current-year',
  SPECIAL_TRAVEL_LAST_2_YEARS = 'special-travel-last-2-years',
  BORN_IN_CANADA = 'born-in-canada',
  SPECIAL_TRAVEL_EXTRA_INFORMATION = 'special-travel-extra-information',
  DRUG_USE_DETAILS = 'drug-use-details',
  DRUG_USE_REASONS = 'drug-use-reasons',
  DRUG_USE_MEDICINAL = 'drug-use-medicinal',
  DRUG_TREATMENT_DETAILS = 'drug-treatment-details',
  DRUG_USE_STOP_REASONS = 'drug-use-stop-reasons',
  DRUG_USE_FUTURE = 'drug-use-future',
  DRUG_USE_EXTRA_INFORMATION = 'drug-use-extra-information',
  NERVOUS_DISORDERS_DETAILS = 'nervous-disorders-details',
  OFF_SCHOOL_OR_WORK_LAST_5_YEARS = 'off-school-or-work-last-5-years',
  NERVOUS_DISORDERS_RECEIVED_TREATMENT = 'nervous-disorders-received-treatment',
  NERVOUS_DISORDERS_FAMILY_HISTORY = 'nervous-disorders-family-history',
  NERVOUS_DISORDERS_ALCOHOL = 'nervous-disorders-alcohol',
  NERVOUS_DISORDERS_DRUGS = 'nervous-disorders-drugs',
  NERVOUS_DISORDERS_DRUG_OR_ALCOHOL_TREATMENT = 'nervous-disorders-drug-or-alcohol-treatment',
  NERVOUS_DISORDERS_SYMPTOMS = 'nervous-disorders-symptoms',
  NERVOUS_DISORDERS_HOSPITALIZATION = 'nervous-disorders-hospitalization',
  NERVOUS_DISORDERS_MEDICATION = 'nervous-disorders-medication',
  NERVOUS_DISORDERS_PHYSICIAN = 'nervous-disorders-physician',
  NERVOUS_DISORDERS_PHYSICIAN_DETAILS = 'nervous-disorders-physician-details',

  // Fna
  HAS_LIFE_INSURANCE = 'has-life-insurance',
  LIFE_INSURANCES_COVERAGE = 'life-insurances-coverage',
  LIFE_INSURANCES_REPLACEMENT = 'life-insurances-replacement',
  CIVIL_STATUS = 'civil-status',
  NUM_CHILDREN = 'num-children',
  YOUNGEST_CHILD_AGE_IN_MONTHS = 'youngest-child-age-in-months',
  SALARY = 'salary',
  MORTGAGE_AMOUNT = 'mortgage-amount',
  DEBT_AMOUNT = 'debt-amount',
  SAVINGS_AMOUNT = 'savings-amount',
}
